import React from 'react'
import github from '../../assets/social-media/github.svg'
import linkedin from '../../assets/social-media/linkedin.svg'
import medium from '../../assets/social-media/medium.svg'
import instagram from '../../assets/social-media/instagram.svg'
import './index.css'
function SocialMedia({ size =35}) {
  const socialWithLink = [
    {
      src: github,
      alt: "Github profile",
      link: "https://github.com/pratikbee",
    },
    {
      src: linkedin,
      alt: "LinkedIn profile",
      link: "https://www.linkedin.com/in/pratik-jha/",
    },
    {
      src: medium,
      alt: "Medium profile",
      link: "https://medium.com/@pratikpro1999",
    },
    {
      src: instagram,
      alt: "Instagram profile",
      link: "https://www.instagram.com/_._.pratik_._/",
    },
  ];
  return (
    <div className="social-media">
      {socialWithLink.map((src) => (
        <a href={src?.link} target="_blank" rel="noopener  noreferrer">
          <img height={size} width={size} src={src?.src} alt={src?.alt} />
        </a>
      ))}
    </div>
  );
}

export default SocialMedia